var SENTRY_RELEASE;SENTRY_RELEASE={name: "HiNote Life TV", version: "4.0.2"};